import HeroBanner from "../../components/store/HeroBanner/HeroBanner";
import Accordian from "../../components/store/Accordian/Accordian";

const FAQs = () => {
  const faq = "./assets/faq.png";
  return (
    <>
      <div className="faq-section">
        <Accordian />
      </div>
    </>
  );
};

export default FAQs;
